import { useEffect, useMemo } from 'react'
import { useAppSelector } from '../redux/hook';
import { useNavigate, useLocation } from 'react-router-dom';
import config from '../config';
import { SingpassTypeEnum } from '../models/enum/singpass-type.enum';


//This hook is to handle solicitor and applicant redirection based on singPassType;
export default function useRouterRedirection() {

  const navigate = useNavigate();
  const location = useLocation();

  const singPassType = useAppSelector(state => state.auth.AuthenticationSlice.singPassType);

  console.log("singPassType", singPassType);

  const redirectPath = useMemo((): string | null => {
    // Don't redirect until singPassType is loaded to prevent looping
    if (singPassType === undefined) {
      return null;
    }
    if (singPassType === SingpassTypeEnum.corppass) {
      return config.corppassRedirectUrl;
    }
    return config.singpassRedirectUrl;
  }, [singPassType])


  useEffect(() => {
    // Only redirect when singPassType is defined (redirectPath is not null)
    if (redirectPath === null) {
      return;
    }

    // Don't redirect if already on the target path to prevent loops
    if (location.pathname === redirectPath) {
      return;
    }
    
    let timeoutId: number;
    timeoutId = window.setTimeout(() => {
      navigate(redirectPath, { replace: true });
    }, 500);
    return () => {
      clearTimeout(timeoutId);
    }
  }, [redirectPath, navigate, location.pathname])


}
